export type BranchCueTime = number | null

/**
 * WIDE型の選択肢表示時刻をノード設定から読む。
 * 0=最初、正数=指定時刻（秒）、null/未設定=末尾。未設定を末尾として扱い既存データを維持する。
 */
export function readBranchCueTime(config: unknown): BranchCueTime {
  if (typeof config !== 'object' || config === null) return null
  const value = (config as Record<string, unknown>).branchCueTime
  return typeof value === 'number' && Number.isFinite(value) && value >= 0 ? value : null
}
